module.exports = __webpack_public_path__ + "static/media/schliffe_frage.b143835a.jpg";